export const BASIC_FIELD_KEYS = ['firstName', 'lastName', 'email', 'category', 'timezone'] as const;

export const REQUIRED_KEYS = ['firstName', 'lastName', 'email', 'category', 'timezone'];

export const OPTIONAL_KEYS = [
  'bio',
  'headshot',
  'dob',
  'country',
  'workHistory',
  'educationHistory',
  'hobbiesInterests',
  'socials',
  'department',
  'companyName',
  'companyInfo',
  'companyPosition'
];
